// native
import { Injectable } from '@angular/core';
import { Observable, throwError, empty } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

// service
import { GlobalsService } from './globals.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private httpClient: HttpClient,
    private globalsService: GlobalsService,
    private authService: AuthService
  ) { }

  private get getHeaders() {
    return new HttpHeaders()
      .set('Content-Type', 'application/json;charset=utf-8')
      .set('X-Readcube-Auth-Token', this.authService.token)
      .set('X-Readcube-Client', this.globalsService.appConfig.environment.clientName)
      .set('X-Readcube-Client-Version', this.globalsService.appConfig.buildVersion);
  }

  private formatErrors(error: any): Observable<string> {
    if (error.status !== 401) {
      return throwError(error);
    } else {
      this.authService.signout();

      return empty();
    }
  }

  get(path: string, params?: HttpParams): Observable<any> {
    return this.httpClient.get(path, { params, headers: this.getHeaders })
      .pipe(
        catchError(error => this.formatErrors(error)),
        map((response: Response) => response)
      );
  }

  getTextFile(path: string): Promise<string> {
    return this.httpClient.get(path, { responseType: 'text', headers: this.getHeaders })
      .pipe(
        catchError(error => this.formatErrors(error))
      ).toPromise();
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.post(path, body, { headers: this.getHeaders })
      .pipe(
        catchError(error => this.formatErrors(error)),
        map((response: Response) => response)
      );
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.patch(path, body)
      .pipe(
        catchError(error => this.formatErrors(error)),
        map((response: Response) => response)
      );
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.put(path, body)
      .pipe(
        catchError(error => this.formatErrors(error)),
        map((response: Response) => response)
      );
  }

  delete(path: string): Observable<any> {
    return this.httpClient.delete(path)
      .pipe(
        catchError(error => this.formatErrors(error)),
        map((response: Response) => response)
      );
  }
}
